<template>
  <div
    class="tw-flex tw-items-start tw-gap-1"
    :class="[indent ? 'tw-pl-4' : '', !selectable && !indent ? 'tw-mt-2' : '']"
  >
    <button
      v-if="selectable"
      type="button"
      :class="[
        buttonHeight,
        active
          ? 'tw-bg-green tw-text-white'
          : 'tw-text-gray-700 hover:tw-bg-gray-100',
        indent ? 'tw-text-sm' : 'tw-font-medium',
      ]"
      class="tw-relative tw-flex tw-min-w-0 tw-flex-1 tw-cursor-pointer tw-items-center tw-rounded tw-px-3 tw-transition-[background] focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-green"
      @click="$emit('select')"
    >
      <span
        class="tw-min-w-0 tw-flex-1 tw-truncate tw-whitespace-nowrap tw-text-left"
        >{{ title }}</span
      >
    </button>
    <div
      v-else
      class="tw-flex tw-h-8 tw-min-w-0 tw-flex-1 tw-items-center tw-px-3 tw-font-semibold tw-tracking-wide tw-text-gray-500"
    >
      <span class="tw-min-w-0 tw-flex-1 tw-truncate">{{ title }}</span>
    </div>
    <c-button-icon
      v-if="isWebmaster"
      flat
      text-color="dark"
      :icon="toClassicIcon(verticalMenuIcon)"
      class="tw-h-10 tw-shrink-0"
      :aria-label="`Acties voor ${title}`"
    >
      <c-menu auto-close>
        <q-list style="min-width: 180px">
          <q-item clickable @click="$emit('edit')">
            <div class="tw-flex tw-items-center tw-gap-3">
              <q-icon size="12px" :name="toClassicIcon(editIcon)" />
              <div>Bewerken</div>
            </div>
          </q-item>
          <q-item clickable @click="$emit('delete')">
            <div class="tw-flex tw-items-center tw-gap-3 tw-text-negative">
              <q-icon size="12px" :name="toClassicIcon(deleteIcon)" />
              <div>Verwijderen</div>
            </div>
          </q-item>
        </q-list>
      </c-menu>
    </c-button-icon>
  </div>
</template>

<script setup lang="ts">
import {
  deleteIcon,
  editIcon,
  toClassicIcon,
  verticalMenuIcon,
} from "common/defaultIcons";
import { computed } from "vue";

interface Props {
  title: string;
  selectable: boolean;
  active: boolean;
  isWebmaster: boolean;
  indent?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  indent: false,
});

defineEmits<{
  (e: "select"): void;
  (e: "edit"): void;
  (e: "delete"): void;
}>();

const buttonHeight = computed(() => {
  if (!props.selectable) {
    return "tw-h-8";
  }
  return props.indent ? "tw-h-9" : "tw-h-10";
});
</script>
